/**
 * API 服务类
 * 提供类型安全的 API 调用方法
 */

import { httpClient } from '@/utils/http'
import { getDeviceInfo } from '@/utils/device'

import type { BaseResponse, LoginRequest, LoginResponse,UserProfile } from '@/types/api'

/**
 * 用户相关 API
 */
export class UserAPI {
  /**
   * 用户登录邮箱
   */
  static async login(data: LoginRequest): Promise<BaseResponse<LoginResponse>> {
    return httpClient.post<LoginResponse>('/login', data)
  }
  /**
   * 用户注册邮箱
   */
  static async register(data: any): Promise<BaseResponse<any>> {
    return httpClient.post<any>('/register', data)
  }

  /**
   * 谷歌登录
   */
  static async googleLogin(thirdToken: any): Promise<BaseResponse<any>> {
    return httpClient.post<any>('/login', {thirdToken: thirdToken})
  }

  /**
   * 获取用户信息
   */
  static async getUserProfile(): Promise<BaseResponse<UserProfile>> {
    return httpClient.post<UserProfile>('/getUserInfo')
  }

  /**
   * 游客登录 - 使用设备信息进行认证
   */
  static async loginTourist(): Promise<BaseResponse> {
    const deviceInfo = getDeviceInfo()

    const response = await httpClient.post('/saveDevice', {
      udid: deviceInfo.udid,
      appId: 'aichat-8e7351e-10cfda-4ed66c-db0wap',
      deviceName: deviceInfo.deviceName,
      systemName: deviceInfo.systemName,
      systemVersion: deviceInfo.systemVersion,
      language: deviceInfo.language,
      timezone: deviceInfo.timezone
    })
    return response
  }
  /**
   * 上传文件
   */
  static async uploadFile(data: any): Promise<any> {
    return httpClient.upload<any>('/upload', data)
  }
}


// 默认导出
export default {
  UserAPI
}
